import { BaseEntity } from 'src/app/core/domain/base.entity';

export class Natureza extends BaseEntity {
  codigo: number;
  descricao: string;
  elemento: string;
}
